import * as authActions from "./authActions";
import * as UiActions from "./UiActions";

const actions = { ...authActions, ...UiActions };

export default actions;
